<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>{{ marketingCalendar.name }}</h2>
        <button class="btn btn-sm btn-primary"
          @click="openGeneralUploadModal(null)"
          style="position: absolute;right: 100px;top: 0;"
        >
          <i class="fa fa-images"></i>
          Upload Pictures
        </button>
        <button class="btn btn-sm btn-primary"
          style="position: absolute;right: 0;top: 0;"
          @click="openFolderModal"
        >
          <i class="fa fa-folder"></i>
          Folders
        </button>
      </div>
      <br>
      <folder-row
        :folders="generalDocumentsFolders"
        @openGeneralUploadModal="openGeneralUploadModal"
      />
      <document-gallary
        :documents="generalDocuments"
        rowClass="col-sm-3"
        @deleteImage="deleteImage"
        :show-drag="true"
      />
    </div>
    <general-documents-folder-modal
      :url="`/marketing_calendars/${marketingCalendar.id}/document_folders`"
    />
    <general-documents-upload-modal
      :url="generalDocumentsUploadUrl"
      @fileUploaded="addDocument"
      :documents="documentsFolder ? documentsFolder.documents : []"
      :isForFolder="documentsFolder"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: ['initMarketingCalendar'],
    data() {
      return {
        marketingCalendar: this.initMarketingCalendar,
        documentsFolder: null,
      }
    },
    methods: {
      openFolderModal() {
        $('#generalDocumentsFolderModal').modal('show')
      },
      openGeneralUploadModal(folder) {
        this.documentsFolder = folder
        this.$nextTick(() => $('#generalDocumentsUploadModal').modal('show'))
      },
      addDocument(doc) {
        if (this.documentsFolder) {
          this.documentsFolder.documents.push(doc)
        } else {
          this.$store.commit('addGeneralDocument', doc)
        }
      },
      deleteImage(doc) {
        if (confirm('Do you really want to delete this image?')) {
          window.axios.delete(`/documents/${doc}`).then(({data}) => {
            window.notification.success(`Image has been deleted`, 'Success!')
            this.$store.commit('removeGeneralDocument', doc)
          })
        }
      },
    },
    computed: {
      ...mapState(['generalDocuments', 'generalDocumentsFolders']),
      generalDocumentsUploadUrl() {
        return this.documentsFolder ?
          `/marketing_calendars/${this.marketingCalendar.id}/general_documents?folder=${this.documentsFolder.id}` :
          `/marketing_calendars/${this.marketingCalendar.id}/general_documents`
      }
    },
    created() {
      this.marketingCalendar.general_documents.forEach(doc => this.$store.commit('addGeneralDocument', doc))
      this.marketingCalendar.folders.forEach(folder => this.$store.commit('addGeneralDocumentsFolder', folder))
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/marketing_calendars/MarketingCalendarShow.vue